module.exports = __webpack_public_path__ + "static/media/reset-password-newpassword.d084d9fe.svg";